document.addEventListener("DOMContentLoaded", function() {
    var descriptionToggle = document.querySelector('[data-toggle="description-toggle"]');

    if (descriptionToggle) {
        descriptionToggle.addEventListener("click", function(e) {
            e.preventDefault();

            const descriptionContent = document.querySelector('[data-toggle="description-content"]');

            if (descriptionContent.style.maxHeight) {
                descriptionContent.style.maxHeight = "";
                descriptionContent.classList.remove("expanded");
                
                this.textContent = "Show more";
            } else {
                descriptionContent.style.maxHeight = "none";
                descriptionContent.classList.add("expanded");
                
                this.textContent = "Show less";
            }
        });
    }
});
